import { formatPrice } from 'src/utilities/helpers';

export class OrderLine {
  constructor (orderLine) {
    this.product = null;
    this.shoppingCartId = orderLine.ShoppingCartId;
    this.productId = orderLine.ProductId;
    this.quantity = parseInt(orderLine.Quantity);
    this.computedQuantity = null;
    this.totalOrderLinesQuantity = orderLine.TotalCount;
    this.rawQuantity = parseInt(orderLine.Quantity);
    this.unitCode = orderLine.UnitCode;
    this.isFree = orderLine.IsFree;
    this.lineId = orderLine.LineId;
    this.comments = orderLine.Comments;
    this.exceedsStock = false;
    this.totals = {
      price: '',
      rawPrice: 0
    };
  }

  setProduct (product) {
    this.product = product;
  }

  getComputedQuantity () {
    let quantity = this.quantity;
    if (this.product.units) {
      const unit = this.product.units.find(unit => unit.code === this.unitCode)
        || this.product.units.find(unit => unit.code === 'STUKS');
      if (unit) {
        quantity = unit.quantity * this.quantity;
      }
    } else if (this.product.saleUnit > 1) {
      quantity = this.product.saleUnit * this.quantity;
    }
    return quantity;
  }

  setComputedQuantity () {
    this.computedQuantity = this.getComputedQuantity();
  }

  setOrderLineTotal () {
    // BESPOKE DEN-496
    // Take priceRaisePercentage into account when setting orderline totals
    let getters = window.vuexStore.$store.getters;
    let priceIncrease = getters.bespokeGlobalWs.priceRaisePercentage;
    let factor = 1 + (priceIncrease / 100);
    // END BESPOKE DEN-496

    let price, totals;
    const quantity = this.getComputedQuantity();
    if (this.product.prices[0].isSalesAction) {
      price = this.product.prices[0].rawBasePrice;
    } else {
      price = this.product.prices[0].rawPrice;
    }
    totals = price * quantity;
    this.totals = {
      // BESPOKE DEN-496
      // Take priceRaisePercentage into account when setting orderline totals
      price: formatPrice(totals * factor),
      rawPrice: totals * factor
      // END BESPOKE DEN-496
    };
  }
}
